import React, { useEffect, useState, createElement } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { ThreeLoopEngine } from './components/ThreeLoopEngine';
import { WhyFailed } from './components/WhyFailed';
import { WhatsInside } from './components/WhatsInside';
import { WhoItsFor } from './components/WhoItsFor';
import { WhatChanges } from './components/WhatChanges';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Legal } from './components/Legal';
import { FlashBanner } from './components/FlashBanner';
import { SocialProofPopup } from './components/SocialProofPopup';
import { SocialTestimonials } from './components/SocialTestimonials';
import { ExitReminderPopup } from './components/ExitReminderPopup';
import { OnlineViewers } from './components/OnlineViewers';
export function App() {
  const [legalView, setLegalView] = useState<'terms' | 'privacy' | null>(null);
  useEffect(() => {
    // Meta Pixel initialization
    const f = window as any;
    if (f.fbq) return;
    const n: any = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(t);
    f.fbq('init', '1584241515962496');
    f.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen w-full bg-[#0a0a0a] text-white selection:bg-[#14b8a6] selection:text-black" data-id="element-0">
      <div className="bg-noise" data-id="element-1" />

      <FlashBanner data-id="element-2" />
      <SocialProofPopup data-id="element-3" />
      <ExitReminderPopup data-id="element-4" />
      <OnlineViewers data-id="element-5" />

      <AnimatePresence data-id="element-6">
        {legalView && <Legal type={legalView} onClose={() => {
        setLegalView(null);
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth'
        });
      }} data-id="element-7" />}
      </AnimatePresence>

      <main className="relative z-10" data-id="element-8">
        <Hero data-id="element-9" />
        <PainPoints data-id="element-10" />
        <ThreeLoopEngine data-id="element-11" />
        <WhyFailed data-id="element-12" />
        <WhatsInside data-id="element-13" />
        <WhoItsFor data-id="element-14" />
        <WhatChanges data-id="element-15" />
        <Testimonials data-id="element-16" />
        <FAQ data-id="element-17" />
        <SocialTestimonials data-id="element-18" />
        <FinalCTA data-id="element-19" />
      </main>

      <footer className="py-10 text-center text-gray-600 text-sm relative z-10 space-y-4" data-id="element-20">
        <div className="luxury-divider max-w-md mx-auto mb-6" data-id="element-21" />
        <p className="tracking-wide" data-id="element-22">
          © {new Date().getFullYear()} Ingresos Digitales Atómicos. Todos los
          derechos reservados.
        </p>
        <div className="flex items-center justify-center gap-4" data-id="element-23">
          <button onClick={() => {
          setLegalView('terms');
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }} className="text-gray-500 hover:text-[#14b8a6] transition-colors underline underline-offset-4 decoration-white/10 hover:decoration-[#14b8a6]/30" data-id="element-24">
            Términos y Condiciones
          </button>
          <span className="text-white/10" data-id="element-25">•</span>
          <button onClick={() => {
          setLegalView('privacy');
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }} className="text-gray-500 hover:text-[#14b8a6] transition-colors underline underline-offset-4 decoration-white/10 hover:decoration-[#14b8a6]/30" data-id="element-26">
            Política de Privacidad
          </button>
        </div>
      </footer>
    </div>;
}